import React from 'react'
import {Icon} from '@chakra-ui/react'

const AlertIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" id="alert" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M38.5803 32.0414L22.6476 4.52649C22.0943 3.57243 21.102 3 20.0049 3C18.9077 3 17.9155 3.57243 17.3622 4.52649L1.4199 32.0414C0.866545 32.9955 0.866545 34.1403 1.4199 35.1039C1.97325 36.0675 2.96547 36.6304 4.07217 36.6304H35.9376C37.0443 36.6304 38.0365 36.058 38.5899 35.1039C39.1432 34.1499 39.1432 33.005 38.5899 32.0414H38.5803ZM36.9298 34.1499C36.8344 34.3216 36.5291 34.7223 35.9376 34.7223H4.06263C3.46157 34.7223 3.16582 34.3216 3.07041 34.1499C2.97501 33.9782 2.77465 33.5202 3.07041 32.9955L19.0031 5.48054C19.2989 4.96535 19.795 4.90811 19.9953 4.90811C20.1957 4.90811 20.6918 4.96535 20.9876 5.48054L36.9203 32.9955C37.216 33.5107 37.0252 33.9782 36.9203 34.1499H36.9298Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.8811 28.5496C19.2037 28.5496 18.6504 29.103 18.6504 29.7804C18.6504 30.4577 19.2037 31.0206 19.8811 31.0206C20.5585 31.0206 21.1119 30.4673 21.1119 29.7804C21.1119 29.0934 20.5585 28.5496 19.8811 28.5496Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.8812 13.3514H19.7094C18.7172 13.4659 17.9921 14.2673 18.0875 15.2118L19.2801 27.2329C19.3564 27.958 20.4059 27.958 20.4727 27.2329L21.6652 15.2118C21.7702 14.2005 20.9211 13.3514 19.8716 13.3514H19.8812ZM19.8812 21.1079L19.2801 15.0974C19.2515 14.8398 19.4709 14.6013 19.8048 14.5631H19.8812H19.9956C20.3009 14.6108 20.5013 14.8493 20.4727 15.0878L19.8716 21.0984L19.8812 21.1079Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default AlertIcon
